"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import * as countdown from "@elements/countdown";
export function init () {
    onFind('.js-countdown', function (baseElement){
        countdown.init({
            endTime: baseElement.getAttribute('data-end-time'),
            prependZero: false,
        });
    });
}